import React from 'react';

const TableHead = () => (
    <thead className="thead-light">
        <tr>
            <th>Detalhes</th>
            <th scope="col">Entidade</th>
            <th scope="col">Valor de Comissão</th>
            <th scope="col">Status</th>
            <th scope="col">Data</th>
        </tr>
    </thead>
);

export default TableHead;



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/TableHead.js